import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

// Import modules
import appointments from "./modules/appointments/index";
import article from "./modules/article/index";
import articles from "./modules/articles/index";
import layout from "./modules/layout/index";
import meeting from "./modules/meeting/index";
import notification from "./modules/notification/index";
import payments from "./modules/payments/index";
import services from "./modules/services/index";
import specialist from "./modules/specialist/index";
import specialists from "./modules/specialists/index";
import stats from "./modules/stats/index";
import user from "./modules/user/index";
import settings from "./modules/settings/index";
import help from "./modules/help/index";
import anytimeMeeting from "./modules/anytimeMeeting/index";

function generateModules() {
    return {
        appointments,
        article,
        articles,
        layout,
        meeting,
        notification,
        payments,
        services,
        settings,
        specialist,
        specialists,
        stats,
        help,
        user,
        anytimeMeeting
    };
}

const initialModules = generateModules();

const store = () => {
    return new Vuex.Store({
        modules: generateModules()
    });
};

export default store;
export { initialModules };
